import { Box, Grid2, Link } from "@mui/material";
import { useEffect, useState } from "react";
import Logo from "../../assets/images/logo.png";
import {
  Button,
  Heading,
  Input,
  Loader,
} from "../../shared/ReusableComponents";
import styles from "./login.module.css";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { sessionRepository } from "../../services/sessionRepository";
import { userRepository } from "../../services/userRepository";
import { login } from "../../store/loginSlice";
import { toast } from "../../store/toastSlice";
import {
  AlertType,
  UserRoles,
  UserRolesInfo,
} from "../../shared/constants/enums";
import {
  AuthConstant,
  errorConstants,
} from "../../shared/constants/all-constant";

import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import React from "react";
import { AuthFunctions } from "../../shared/utils/AuthFunctions";
import { cssVar } from "../../theme/theme";
const { version } = require("../../../package.json");

const Login = ({ instanceCallback }: { instanceCallback: any }) => {
  const { inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const [selectedRole, setSelectedRole] = React.useState("student");
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const auth = useSelector((state: any) => state.login);
  const [isLoading, setIsLoading] = useState(false);
  const [isRoleSelected, setIsRoleSelected] = useState(false);
  const [credentials, setCredentials] = useState({
    username: "",
  });
  const [errors, setErrors] = useState({ username: "" });

  useEffect(() => {
    const itemKey = "msal.interaction.status";
    if (sessionStorage.getItem(itemKey)) {
      sessionStorage.removeItem(itemKey);
    }
  }, [sessionStorage.length]);

  useEffect(() => {
    if (auth && auth.authenticated) {
      if (location.state) {
        navigate("/");
      } else {
        const userRole =
          // auth.userInfo?.roleId === UserRoles.TUTOR
          //   ? UserRolesInfo[UserRoles.NURSING_STUDENT] :
          UserRolesInfo[auth.userInfo?.roleId as UserRoles];

        navigate(userRole?.route);
      }
    }
  }, [auth, location.state, navigate]);

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setCredentials({ ...credentials, [name]: value });

    if (name === "username" && value !== "") {
      setErrors((prevErrors) => ({ ...prevErrors, username: "" }));
    }
  };

  const handleSubmit = (event: any) => {
    event.preventDefault();
    let validationErrors: any = {};
    let isValid = true;
    // Username validation
    if (!credentials.username.trim()) {
      validationErrors.username = "User name is required.";
      isValid = false;
    }
    setErrors(validationErrors);

    if (isValid) {
      AuthFunctions.InitializeMsal(selectedRole).then(async (ssoInstance) => {
        instanceCallback(ssoInstance);
        ssoInstance
          .loginPopup({
            scopes: ["user.read"],
            prompt: "select_account",
          })
          .then((response: any) => {
            if (response && response.account) {
              ValidateSSOResponse(response);
            } else {
              setErrors((prevErrors) => ({
                ...prevErrors,
                username: "Single Sign On failed, Try again.",
              }));
            }
          })
          .catch((reject: any) => {
            dispatch(
              toast({
                isOpen: true,
                message: reject.errorMessage,
                type: AlertType.ERROR,
              })
            );
          });
      });
    }
  };

  const ValidateSSOResponse = (response: any) => {
    const userName = response?.account?.username;
    if (userName.toLowerCase() !== credentials.username.toLowerCase()) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        username: "User name does not match.",
      }));
      dispatch(
        toast({
          isOpen: true,
          message: "User name does not match.",
          type: AlertType.ERROR,
        })
      );
      // instance.logoutRedirect({
      //   onRedirectNavigate: () => {
      //     return false;
      //   },
      // });
      return;
    }
    setIsLoading(true);
    sessionRepository
      .Login({
        UserName: credentials.username,
        AccessToken: response.accessToken,
        ExpiresOn: response.expiresOn,
      })
      .then((loginResult) => {
        localStorage.setItem(AuthConstant.AUTH_TOKEN, response.accessToken);
        localStorage.setItem(
          AuthConstant.LOGIN_USER_NAME,
          credentials.username
        );
        if (!loginResult || !loginResult.userName) {
          let errorMessage = errorConstants.CREDENTIALS;
          if (loginResult?.code?.includes("ERR_NETWORK")) {
            errorMessage = errorConstants.TIMEOUT;
          } else {
            errorMessage =
              loginResult?.message.data.errorList[0] ??
              errorConstants.CREDENTIALS;
          }
          setErrors({
            username: errorMessage,
          });
          dispatch(
            toast({
              isOpen: true,
              message: errorMessage,
              type: AlertType.ERROR,
            })
          );
        } else {
          userRepository.GetCurrentUser().then((userResult) => {
            if (!userResult) {
              dispatch(
                toast({
                  isOpen: true,
                  message: errorConstants.CREDENTIALS,
                  type: AlertType.ERROR,
                })
              );
            }
            setErrors({ username: "" });
            dispatch(
              login({
                token: response.accessToken,
                userData: userResult,
              })
            );
            dispatch(
              toast({
                isOpen: true,
                message: `${userResult.userFirstName} ${userResult.userLastName} logged in successfully.`,
                type: AlertType.SUCCESS,
              })
            );
          });
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  if (!isAuthenticated && inProgress !== InteractionStatus.None) {
    return <div>Loading...</div>;
  }
  return (
    <React.Fragment>
      {isLoading && <Loader />}
      <Grid2 container component="main">
        <Grid2
          container
          flexDirection={"column"}
          justifyItems={"flex-start"}
          size={{ md: 6, lg: 6, xl: 6 }}
        >
          <Grid2
            container
            flexDirection={"column"}
            size={{ sm: 12, md: 12 }}
            rowSpacing={3}
            sx={{ padding: [0, 17.25] }}
          >
            <img src={Logo} alt="logo" className={styles.logoImage} />
            <Grid2
              container
              flexDirection={"column"}
              rowSpacing={1}
              className={styles.leftSection}
            >
              <Heading type="h1" text="Welcome back" />
              <Heading type="caption" text="Please choose your login type" />
            </Grid2>
            <Grid2
              container
              flexDirection={"column"}
              rowSpacing={2}
              style={{ width: "340px" }}
            >
              {!isRoleSelected && (
                <React.Fragment>
                  <Button
                    text="Student"
                    size="large"
                    variant="outlined"
                    isBold={true}
                    className="loginButton"
                    onClick={() => {
                      setSelectedRole("student");
                      setIsRoleSelected(true);
                    }}
                  />
                  <Button
                    text="Staff"
                    className="loginButton"
                    variant="outlined"
                    size="large"
                    isBold={true}
                    onClick={() => {
                      setSelectedRole("staff");
                      setIsRoleSelected(true);
                    }}
                  />
                </React.Fragment>
              )}

              {isRoleSelected && (
                <React.Fragment>
                  <Input
                    label=""
                    placeholder={
                      selectedRole === "student"
                        ? "Student@student.westernsydney.edu.au"
                        : "Staff@westernsydney.edu.au"
                    }
                    name="username"
                    value={credentials.username}
                    hasError={errors.username}
                    onChange={handleChange}
                    size="medium"
                  />
                  <Link
                    sx={{
                      cursor: "pointer",
                      color: "info.main",
                      textDecorationColor: cssVar("--color-info-main"),
                      flexShrink: 0,
                      textAlign: "right",
                    }}
                    onClick={() => {
                      setSelectedRole(
                        selectedRole === "student" ? "staff" : "student"
                      );
                    }}
                  >
                    <span>
                      {selectedRole === "student"
                        ? "Switch to Staff"
                        : "Switch to Student"}
                    </span>
                  </Link>
                  <Button
                    text="Sign in"
                    size="large"
                    isBold={true}
                    onClick={handleSubmit}
                    className="sign-btn"
                  />
                </React.Fragment>
              )}
            </Grid2>
          </Grid2>
        </Grid2>

        {/* Right Section (Grid of 6/12) */}
        <Grid2 size={{ md: 6, lg: 6, xl: 6 }} className={styles.imageSection}>
          <div className={styles.version}>{`${version}`}</div>
          <Box className={styles.infoSection}>
            <Grid2 size={{ sm: 12, md: 12 }} sx={{ paddingTop: 10 }}>
              <Heading type="h1" classes={styles.rightHeading} text="YOUR" />
              <Heading
                type="h1"
                classes={styles.rightHeading}
                text="LEARNING."
              />
              <Heading
                type="h1"
                classes={styles.rightHeading}
                text="RE-IMAGINED."
              />
            </Grid2>
            <Heading
              type="h4"
              classes={styles.rightDescription}
              text="Our new modular learning at The College offers an inspiring
                first year alternative in 2025. Flex your studies around your
                life and career goals with a timetable designed for busy lives."
            />
          </Box>
        </Grid2>
      </Grid2>
    </React.Fragment>
  );
};

export default Login;
